import { useQuery } from '@tanstack/react-query';
import type { SurveyTaking } from '@/models/survey';
export const useSurveyTakingQuery = ({
  surveyId,
  entryId,
  enabled
}: {
  surveyId?: string;
  entryId?: string;
  enabled?: boolean;
}) => {
  const query = useQuery({
    queryFn: async () => {
      try {
        const response = await fetch(`${process.env.API_URL ?? ''}/surveys/${surveyId}/form${entryId ? `/${entryId}` : ''}`, {
          method: 'GET'
        });
        const data = await response.json();
        const survey: SurveyTaking = data.data[0];
        if (survey.type.slug === 'graded') {
          return {
            ...survey,
            entry: survey.entry,
            timer: survey.surveyable.timer,
            total_grade: survey.surveyable.total_grade,
            has_results_showed: survey.surveyable.has_results_showed
          };
        }
        return survey;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    queryKey: ['survey', 'taking', surveyId],
    enabled
  });
  return {
    ...query,
    survey: query.data
  };
};